module.exports = "/cyber/_next/static/images/winners-bg-tablet-86a9d486cd2f6f5c7fd3ee9d8b05a25d.jpg";